// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Chrome / Edge */

.subtitle-list-errors::-webkit-scrollbar {
    width: 8px;
}

.subtitle-list-errors::-webkit-scrollbar-track {
    background: transparent;
}

.subtitle-list-errors::-webkit-scrollbar-thumb {
    background: rgba(140,190,255,0.25);
    border-radius: 4px;
}

.subtitle-list-errors::-webkit-scrollbar-thumb:hover {
    background: rgba(140,190,255,0.45);
}

`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/subtitleerrors/displayerrorslist.css"],"names":[],"mappings":";AACA,kBAAkB;;AAElB;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":["\n/* Chrome / Edge */\n\n.subtitle-list-errors::-webkit-scrollbar {\n    width: 8px;\n}\n\n.subtitle-list-errors::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.subtitle-list-errors::-webkit-scrollbar-thumb {\n    background: rgba(140,190,255,0.25);\n    border-radius: 4px;\n}\n\n.subtitle-list-errors::-webkit-scrollbar-thumb:hover {\n    background: rgba(140,190,255,0.45);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
